var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home container px-3 px-md-5"},_vm._l((_vm.contentfulComponents),function(elm,index){return _c('div',{key:index},[_c(_vm.returnEntryTemplate(elm.sys.id),{tag:"component",attrs:{"entryData":elm.sys.id}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }